/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import axios from "axios";
import config from '../../../config/config';
import styles from './MainDashboard.module.css';
import './MainDashboard.css';
import DomainTile from '../../DomainTile/DomainTile';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import AnnualTax from '../TDSPages/AnnualTax';
import MonthlySectionTable from '../TDSPages/TDSReturns';
import ReusableBarChart from '../DepartmentalNotices/DepartmentalNotice';
import TaxComplianceChart from '../AnnualTaxFilings/AnnualTaxFilings';
import TrendIndicator from '../../RecordToReportComp/RecordToReportTrendIndicator/RecordToReportTrendIndicator';
import IndirectTaxPieChart from '../../IndirectTaxComp/IndirectTaxPieChart/IndirectTaxPieChart';
import DetailedDomainTile from '../../../atomicComponents/DetailedDomainTile/DetailedDomainTile';

const { API_BASE_URL } = config;

const quarterOptions = [
  { value: 'Q1', label: 'Q1' },
  { value: 'Q2', label: 'Q2' },
  { value: 'Q3', label: 'Q3' },
  { value: 'Q4', label: 'Q4' },
];

const monthOptions = [
  { value: '01', label: 'Jan' },
  { value: '02', label: 'Feb' },
  { value: '03', label: 'Mar' },
  { value: '04', label: 'Apr' },
  { value: '05', label: 'May' },
  { value: '06', label: 'Jun' },
  { value: '07', label: 'Jul' },
  { value: '08', label: 'Aug' },
  { value: '09', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

const DirectTaxDashboard = () => {
  const location = useLocation();
  const initialFilters = location.state || {
    entityData: [],
    yearData: null,
    monthData: null,
    quarterData: null,
  };

  const [filters, setFilters] = useState(initialFilters);
  const [entity, setEntity] = useState();
  const [year, setYear] = useState();
  const [quarter, setQuarter] = useState();
  const [month, setMonth] = useState();
  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);

  const [DepartmentalNoticeData, setDepartmentalNoticeData] = useState([]);
  const [annualdata, setannualdata] = useState({});
  const [annualTaxValue, setannualTaxValue] = useState("");
  const [changeAnnualTax, setchangeAnnualTax] = useState(`Cr`);
  const [pieNotCompleted, setpieNotCompleted] = useState("");
  const [pieCompleted, setpieCompleted] = useState("");
  const [tdstabledata, settdstabledata] = useState([]);
  const [sampleData, setsampleData] = useState([]);
  const [months, setmonths] = useState([]);
  const [hasApplied, setHasApplied] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleQuarterChange = (selected) => {
    setQuarter(selected);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const samples = {
    labels: ['Compliant', 'Non Compliant'],
    datasets: DepartmentalNoticeData
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/direct-tax-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setEntityOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/direct-tax-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const handleApply = () => {
    setShowDashboard(false);
    setIsLoading(true);
    const entityFilterData = entity?.value || '';
    const yearFilterData = year?.value || '';
    const monthFilterData = month?.value || '';
    const quarterFilterData = quarter?.value || '';

    const fetchDeparmentalNoticeData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/direct-tax-departmental-notice`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterFilterData
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            // console.log("test check submit", response.data.departmental_datalabels);
            setDepartmentalNoticeData(response.data.departmental_datalabels);
            setannualdata(response.data.annual_tax_data);
            setannualTaxValue(response.data.advancce_tax_percent_data);
            setchangeAnnualTax(`${response.data.advancce_tax_percent_change_data} Cr`);
            setpieCompleted(response.data.pie_precent_data.complete);
            setpieNotCompleted(response.data.pie_precent_data.notcompleted);
            settdstabledata(response.data.TDS_table_data);
            setsampleData(response.data.sectionwise_table_data);
            setmonths(response.data.sectionwise_table_columns);

          })
      } catch (error) {
        console.error('Error fetching entity options:', error);
        setDepartmentalNoticeData([]);
        setannualdata({});
        setannualTaxValue("");
        setchangeAnnualTax("Cr");
        setpieCompleted("");
        setpieNotCompleted([]);
        settdstabledata([]);
        setsampleData([]);
        setmonths([]);
      }
    };

    Promise.all([fetchDeparmentalNoticeData()]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    // console.log("main page filter check -------------->", filters);
  }, []);

  const handleReset = () => {
    // setEntity(null);
    setEntity([]);
    setYear(null);
    setQuarter(null);
    setMonth(null);
    setFilters({
      entityData: null,
      geographyData: null,
      yearData: null,
      quarterData: null,
      monthData: null,
    });
    setShowDashboard(false);
  };

  useEffect(() => {
    // console.log("test log -------------->", entityOptions, quarterOptions.length, yearOptions.length, monthOptions.length);

    if (entityOptions.length && quarterOptions.length && yearOptions.length && monthOptions.length) {
      if (filters.entityData) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }

      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData?.value) {
        const mon = monthOptions.find(opt => opt.value === filters.monthData.value);
        if (mon) setMonth(mon);
      }

      if (filters.quarterData?.value) {
        const qtr = quarterOptions.find(opt => opt.value === filters.quarterData.value);
        if (qtr) setQuarter(qtr);
      }

      // setHasApplied(true);
      // if (filters.entityData.length > 0) {
      //   setTimeout(() => {
      //     setHasApplied(true);
      //   }, 1000);
      // }
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);

  const fetchData = (filters) => {
    // console.log("Fetching with", filters);
    if (filters.entityData && filters.entityData.value) {
      setTimeout(() => {
        setHasApplied(true);
      }, 1000);
    }
  };

  useEffect(() => {
    fetchData(filters);
  }, []);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);


  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                placeholder="Select Entity"
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">Apply</button>
            <button onClick={handleReset} className="btn reset-btn">Reset</button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>

          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div className={styles.dashboard_container}>
            <div className={styles.top_row}>
              <div className={styles.left_col}>
                <DetailedDomainTile title="TDS Returns Filing and Payment" showButton={true} path="/Direct-Tax/TDSReturns" detailState={filters} />
                <DashboardSection title="" disableDetailView={true} height={'300px'} detailPath="/Direct-Tax/TDSReturns" detailState={filters}>
                  <div className="row mb-4">
                    <div className='row'>
                      <div className='col-7'>
                        <DashboardSection title="Advance Tax Payment" disableDetailView={false} detailPath="/Direct-Tax/AdvanceTax" detailState={filters}>
                          <TrendIndicator
                            value={annualTaxValue}
                            changeText={changeAnnualTax}
                            isIncrease={true}
                            showArrow={true}
                          />
                        </DashboardSection>
                      </div>
                      <div className='col-5' style={{ marginTop: "40px" }}>
                        <IndirectTaxPieChart Completed={pieCompleted} Pending={pieNotCompleted}></IndirectTaxPieChart>
                      </div>
                    </div>
                    <div className='row mt-4 mb-4'>
                      <div className='col-12'>
                        <AnnualTax data={tdstabledata} />
                      </div>
                    </div>
                    <MonthlySectionTable tableData={sampleData} months={months} />
                  </div>
                </DashboardSection>
              </div>
              <div className={styles.right_col}>
                <DetailedDomainTile title="Tax Assesments and Appeals" showButton={true} path="/Direct-Tax/Departmental-Notice" detailState={filters} />
                <DashboardSection title="" disableDetailView={true} detailPath="/Direct-Tax/Departmental-Notice" detailState={filters}>
                  <div style={{ width: '100%', height: '50%' }}>
                    <ReusableBarChart
                      data={samples}
                      title="Compliance Overview"
                      width="100%"
                      height={300}
                      colors={['#a8d5a8', '#ffb380']}
                    />
                  </div>
                </DashboardSection>
                <div style={{ paddingTop: "10px", marginBottom: '60px' }}>
                  <DetailedDomainTile title="Annual Tax Filings" showButton={true} path="/Direct-Tax/AnnualTaxFilling" detailState={filters} />
                  <DashboardSection title="" disableDetailView={true} detailPath="/Direct-Tax/AnnualTaxFilling" detailState={filters}>
                    <TaxComplianceChart data={annualdata} height={300} />
                  </DashboardSection>
                </div>
              </div>
            </div>
          </div>
        </>)}
    </>
  );
};

export default DirectTaxDashboard;

